import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiCheck, FiClock, FiMoreHorizontal } from 'react-icons/fi';
import { TIMELINE_DATA } from '../data/mockData';

export default function Timeline() {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="h-full flex flex-col pb-20 sm:pb-0"
    >
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-white">Event Timeline</h1>
          <p className="text-[#94A3B8] text-sm mt-1">Master schedule & execution lanes</p>
        </div>
        <button className="bg-[#9D4EDD]/10 hover:bg-[#9D4EDD]/20 text-[#9D4EDD] border border-[#9D4EDD]/30 px-4 py-2 rounded-lg text-sm font-medium transition-colors">
          + Add Sequence
        </button>
      </div>

      <div className="glass-panel flex-1 overflow-y-auto p-6 relative">
        {/* Timeline Line */}
        <div className="absolute left-[47px] md:left-[87px] top-6 bottom-6 w-0.5 bg-gradient-to-b from-[#9D4EDD] via-[#2A2A35] to-[#2A2A35]"></div>

        <div className="space-y-8 relative">
          {TIMELINE_DATA.map((item, index) => {
            const isCompleted = item.status === 'completed';
            const isActive = item.status === 'active';
            
            return (
              <motion.div 
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                key={item.id} 
                className="flex items-start gap-4 md:gap-6 group"
              >
                {/* Time */}
                <div className="w-12 md:w-20 pt-3 text-right shrink-0">
                  <span className={`font-mono text-sm md:text-base ${isActive ? 'text-[#E5C158] text-glow-gold' : isCompleted ? 'text-[#94A3B8]' : 'text-white'}`}>
                    {item.time}
                  </span>
                </div>

                {/* Node */}
                <div className="relative mt-3 shrink-0 z-10">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 
                    ${isCompleted ? 'bg-[#12121c] border-green-500/50 text-green-400' : 
                      isActive ? 'bg-[#9D4EDD] border-[#9D4EDD] text-white shadow-[0_0_15px_#9D4EDD]' : 
                      'bg-[#12121c] border-[#333] text-[#666]'}`}
                  >
                    {isCompleted ? <SafeIcon icon={FiCheck} /> : isActive ? <SafeIcon icon={FiClock} className="animate-pulse" /> : <div className="w-2 h-2 rounded-full bg-[#444]"></div>}
                  </div>
                </div>

                {/* Card */}
                <div className={`flex-1 rounded-xl p-4 border transition-all duration-300
                  ${isActive ? 'bg-gradient-to-r from-[#9D4EDD]/10 to-transparent border-[#9D4EDD]/40' : 
                    isCompleted ? 'bg-black/20 border-white/5 opacity-60' : 
                    'bg-[#1A1A24] border-white/10 hover:border-white/20'}`}
                >
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className={`font-semibold text-lg ${isActive ? 'text-white' : isCompleted ? 'text-[#94A3B8] line-through decoration-white/20' : 'text-white/90'}`}>
                        {item.title}
                      </h3>
                      <div className="flex items-center gap-3 mt-2">
                        <span className="text-xs text-[#94A3B8] bg-black/30 px-2 py-1 rounded">Owner: {item.owner}</span>
                        <span className="text-[10px] uppercase tracking-wider text-[#666]">{item.type}</span>
                      </div>
                    </div>
                    <button className="text-[#666] hover:text-white p-1">
                      <SafeIcon icon={FiMoreHorizontal} />
                    </button>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </motion.div>
  );
}